import { postInternalMessage } from '../initialize';
import { REGISTER_FROM_NUMBER_HOST_MSG } from '../methods/callingSharedWorkerMessageTypes';
export function createRegisterFromNumberMessage() {
  return {
    type: REGISTER_FROM_NUMBER_HOST_MSG
  };
}
export default function registerFromNumberHandler() {
  postInternalMessage(createRegisterFromNumberMessage());
}